import { Subscription } from 'rxjs';
import { IBaseService } from '../services/misc/base.service';

export interface IPITEventService extends IBaseService {

  releaseSubscriptionForEvent(eventName: string, subscription: Subscription): void;
  subscribeForEvent(eventName: string, method: (value: any) => void): Subscription;

  registerMethod(methodName: string, method: (value?: any) => void): void;
  useMethod(methodName: string, value?: any): void;

  sendEvent(eventName: string, event?: any): void;

}
